import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Button = ({ to, className, ariaLabel, text, onClick, type = 'text' }) => {

    const [clickEvent, setClickEvent] = useState(false);
    var timer = null;
    var html = '';
    switch (type) {
        default:
        case "text":
            html = '<span>' + text + '</span>';
            break;
        case "360":
            html = `<span>${text}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="15" viewBox="0 0 44 15">
                        <path fill="#FFF" d="M5.393 14.474c.979 0 1.857-.17 2.635-.513.778-.342 1.384-.831 1.82-1.468.436-.637.654-1.398.654-2.283 0-1.288-.399-2.267-1.197-2.937-.798-.67-1.88-1.026-3.249-1.066h-.321L9.657 1.8c.134-.16.201-.315.201-.463V.675c0-.148-.043-.265-.13-.352C9.64.235 9.523.192 9.376.192H1.41c-.135 0-.245.043-.332.13C.99.41.947.528.947.676v.724c0 .134.043.241.13.322.088.08.198.12.333.12h5.954L3.44 6.187c-.147.147-.221.321-.221.523v.523c0 .134.044.244.13.331.088.088.199.131.333.131h1.89c1.999 0 2.998.818 2.998 2.454 0 .859-.285 1.52-.855 1.982-.57.463-1.338.694-2.303.694-.792 0-1.479-.14-2.062-.423-.584-.281-.962-.764-1.137-1.448-.053-.174-.127-.292-.221-.352s-.215-.09-.362-.09H.726c-.121 0-.222.036-.302.11-.08.074-.12.171-.12.292.026.59.237 1.16.633 1.71.395.55.975.995 1.74 1.337.764.342 1.67.513 2.716.513zm12.25 0c1.06 0 1.978-.22 2.756-.663.778-.443 1.372-1.036 1.78-1.78.41-.745.614-1.546.614-2.405 0-.858-.204-1.646-.613-2.363-.41-.718-.986-1.294-1.73-1.73-.745-.436-1.606-.654-2.585-.654-.43 0-.818.04-1.167.12L19.635.897c.067-.107.1-.195.1-.262 0-.12-.036-.224-.11-.311-.074-.088-.171-.131-.292-.131h-.986c-.12 0-.228.023-.321.07-.094.047-.171.11-.232.191-.06.08-.097.128-.11.141L13.84 5.945c-.925 1.314-1.388 2.548-1.388 3.702 0 .871.205 1.676.614 2.413.409.738 1.006 1.325 1.79 1.76.785.436 1.713.654 2.786.654zm-.02-1.67c-.576 0-1.113-.12-1.61-.361-.495-.242-.89-.6-1.186-1.077-.295-.476-.442-1.049-.442-1.72 0-.657.147-1.223.442-1.7.295-.475.69-.838 1.187-1.086.496-.248 1.033-.372 1.61-.372.576 0 1.112.124 1.609.372.496.248.895.61 1.196 1.087.302.476.453 1.042.453 1.7 0 .67-.147 1.243-.442 1.72-.296.476-.691.834-1.187 1.076-.497.241-1.04.362-1.63.362zm12.271 1.67c1.744 0 3.014-.506 3.812-1.518.798-1.013 1.224-2.337 1.278-3.973.013-.362.02-.94.02-1.73 0-.818-.007-1.415-.02-1.79-.04-1.623-.466-2.941-1.278-3.954-.811-1.012-2.082-1.518-3.812-1.518-1.716 0-2.98.506-3.792 1.518-.811 1.013-1.237 2.33-1.277 3.953l-.02 1.79.02 1.73c.054 1.637.48 2.961 1.277 3.974.798 1.012 2.062 1.518 3.792 1.518zm0-1.67c-1.02 0-1.79-.341-2.313-1.025-.523-.684-.798-1.65-.825-2.897l-.02-1.67.02-1.65c.027-1.233.302-2.195.825-2.886.523-.69 1.294-1.036 2.313-1.036 1.02 0 1.794.346 2.324 1.036.53.69.808 1.653.834 2.887.014.362.02.912.02 1.65 0 .724-.006 1.28-.02 1.67-.026 1.246-.301 2.212-.824 2.896-.523.684-1.301 1.026-2.334 1.026zm10.26-7.14c.536 0 1.029-.125 1.478-.373.45-.248.805-.59 1.066-1.026.262-.435.392-.915.392-1.438 0-.536-.13-1.02-.392-1.448-.261-.43-.617-.768-1.066-1.016-.45-.248-.942-.372-1.479-.372-.536 0-1.029.124-1.478.372-.45.248-.805.587-1.066 1.016-.262.429-.393.912-.393 1.448 0 .523.131 1.003.393 1.438.261.436.617.778 1.066 1.026.45.248.942.372 1.478.372zm0-1.308c-.456 0-.825-.14-1.107-.423-.282-.281-.422-.65-.422-1.106 0-.456.14-.825.422-1.106.282-.282.65-.423 1.106-.423.456 0 .825.141 1.107.423.281.281.422.65.422 1.106 0 .456-.14.825-.422 1.106-.282.282-.65.423-1.107.423z" />
                    </svg>`;
            break;
        case "home":
            html = `<span>${text}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="28" viewBox="0 0 25 28">
                        <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                            <path d="M0 8.723L11.215 0l11.216 8.723v13.708c0 1.376-1.116 2.492-2.493 2.492H2.492C1.116 24.923 0 23.807 0 22.431V8.723z" transform="translate(1 1.17)"/>
                            <path d="M7.477 24.923L7.477 16.2 14.954 16.2 14.954 24.923" transform="translate(1 1.17)"/>
                        </g>
                    </svg>
                    <svg class="progress-circle" xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66">
                        <defs>
                            <clipPath id="cFrame">
                            <circle cx="33" cy="33" r="30" /> 
                            </clipPath>
                        </defs>
                        <circle transform="translate(0,66) rotate(-90)" id="pbar" class="showAnim" cx="33" cy="33" r="30" />
                    </svg>
                    `;
            break;

        case "audio":
            html = `<span>${text}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24">
                        <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                            <path d="M6.705 0C5.118 0 3.83 1.28 3.83 2.857v7.62c0 1.577 1.287 2.856 2.874 2.856 1.586 0 2.873-1.279 2.873-2.857V2.857C9.578 1.28 8.29 0 6.705 0z" transform="translate(1 1.714)"/>
                            <path d="M13.41 8.571v1.905c0 3.682-3.003 6.667-6.705 6.667C3.002 17.143 0 14.158 0 10.476V8.571M6.705 17.143L6.705 20.952M2.873 20.952L10.536 20.952" transform="translate(1 1.714)"/>
                        </g>
                    </svg> 
                    <svg class="progress-circle" xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66">
                        <defs>
                            <clipPath id="cFrame">
                            <circle cx="33" cy="33" r="30" /> 
                            </clipPath>
                        </defs>
                        <circle transform="translate(0,66) rotate(-90)" id="audio-pbar" class="showAnim" cx="33" cy="33" r="30" />
                    </svg>
                    `;
            break;

        case "video":
            html = `<span>${text}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19">
                    <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M0 0L13.611 8.5 0 17z" transform="translate(1 1)"/>
                </svg> 
                <svg class="progress-circle" xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66">
                    <defs>
                        <clipPath id="cFrame">
                        <circle cx="33" cy="33" r="30" /> 
                        </clipPath>
                    </defs>
                    <circle transform="translate(0,66) rotate(-90)" id="vid-pbar" class="showAnim" cx="33" cy="33" r="30" />
                </svg>
                `;
            break;

        case "no-sound":
            html = `<span>${text}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="34" viewBox="0 0 35 34">
                <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="2">
                    <g stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9.378 0C7.158 0 5.36 1.795 5.36 4.009v10.69c0 2.213 1.8 4.008 4.02 4.008 2.219 0 4.018-1.795 4.018-4.009V4.008C13.397 1.796 11.598 0 9.378 0z" transform="translate(1 1) translate(9 1)"/>
                        <path d="M18.756 12.026v2.672c0 5.166-4.198 9.354-9.378 9.354S0 19.864 0 14.698v-2.672M9.378 24.052L9.378 29.397M4.019 29.397L14.737 29.397" transform="translate(1 1) translate(9 1)"/>
                    </g>
                    <path stroke-linecap="square" d="M0.5 31.5L32.5 0.5" transform="translate(1 1)"/>
                </g>
            </svg>
             
                    `;
            break;



        case "back":
            html = `<span>${text}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
                        <g fill="#FFF">
                            <path d="M21.185 8.723L21.185 11.215 -2.492 11.215 -2.492 8.723z" transform="rotate(90 9.846 10.623) rotate(-45 9.346 9.97)"/>
                            <path d="M21.185 8.723L21.185 11.215 -2.492 11.215 -2.492 8.723z" transform="rotate(90 9.846 10.623) rotate(45 9.346 9.97)"/>
                        </g>
                    </svg>
    
                </svg> 
                `;
            break;

        case "info":
            html = `<span>${text}</span> 
                <svg width="12px" height="29px" viewBox="0 0 12 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>C7A4E585-A535-44F9-831C-28447BFCE8FE</title>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Symbols" transform="translate(-452.000000, -72.000000)" fill="#fff" fill-rule="nonzero">
                            <path d="M460.683828,76.9846154 C461.403392,76.9846154 462.005209,76.7230769 462.489279,76.2 C462.973349,75.6769231 463.215385,75.0646154 463.215385,74.3630769 C463.215385,73.7353846 462.979891,73.1846154 462.508904,72.7107692 C462.037916,72.2369231 461.429558,72 460.683828,72 C460.016596,72 459.440945,72.2523077 458.956875,72.7569231 C458.472804,73.2615385 458.230769,73.8523077 458.230769,74.5292308 C458.230769,75.1692308 458.472804,75.7384615 458.956875,76.2369231 C459.440945,76.7353846 460.016596,76.9846154 460.683828,76.9846154 Z M456.051304,100.661538 C456.52578,100.661538 457.097586,100.573824 457.76672,100.398394 C458.435855,100.222965 459.330061,99.9114264 460.44934,99.4637789 L460.44934,99.4637789 L460.723077,98.3023152 C460.491921,98.3870052 460.160396,98.4595967 459.7285,98.5200896 C459.296604,98.5805825 458.965079,98.610829 458.733923,98.610829 C458.040457,98.610829 457.538606,98.4837939 457.228371,98.2297237 C456.918136,97.9756535 456.763019,97.5038088 456.763019,96.8141897 C456.763019,96.5238237 456.808642,96.1517924 456.899887,95.6980956 C456.991133,95.2443988 457.097586,94.7816281 457.219247,94.3097834 L457.219247,94.3097834 L459.171902,86.596938 C459.269231,86.221882 459.342227,85.846826 459.390892,85.47177 C459.439556,85.096714 459.463888,84.8002987 459.463888,84.5825243 C459.463888,83.7840179 459.238816,83.1488424 458.788671,82.6769978 C458.338526,82.2051531 457.614644,81.9692308 456.617026,81.9692308 C456.179047,81.9692308 455.58291,82.0720687 454.828613,82.2777446 C454.074316,82.4834205 453.222691,82.7979836 452.273737,83.2214339 L452.273737,83.2214339 L452,84.3828977 C452.231155,84.3224048 452.568764,84.2498133 453.012826,84.1651232 C453.456888,84.0804332 453.812745,84.0380881 454.080399,84.0380881 C454.773865,84.0380881 455.233135,84.15 455.458207,84.3738237 C455.68328,84.5976475 455.795816,85.0483196 455.795816,85.7258402 C455.795816,86.0646004 455.750193,86.4759522 455.658948,86.9598954 C455.567702,87.4438387 455.473415,87.8975355 455.376086,88.3209858 L455.376086,88.3209858 L453.44168,96.0338312 C453.332185,96.4935773 453.253106,96.8746826 453.204442,97.1771471 C453.155777,97.4796117 453.131445,97.7699776 453.131445,98.048245 C453.131445,98.7862584 453.374767,99.4063107 453.86141,99.9084018 C454.348053,100.410493 455.078017,100.661538 456.051304,100.661538 Z" id="info"></path>
                        </g>
                    </g>
                </svg> 
            `;
            break;

        case "prev-text":
            html = `<span>${text}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="20" viewBox="0 0 39 20">
                <path fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M249 502.211L232 520.056 249 537.211" transform="matrix(0 1 1 0 -500.21 -230.79)"/>
            </svg>
            
                    `;
            break;

        case "next-text":
            html = `<span>${text}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="39" height="20" viewBox="0 0 39 20">
                <path fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M349 502.211L332 520.056 349 537.211" transform="rotate(-90 -75 425.21)"/>
            </svg>
                        `;
            break;

        case "prev":
            html = `<span>${text}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38">
                    <path fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M105 502.211L88 520.056 105 537.211" transform="translate(-86 -501)"/>
                </svg>
                `;
            break;

        case "next":
            html = `<span>${text}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="38" viewBox="0 0 21 38">
                        <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M155 502.211L138 520.056 155 537.211" transform="matrix(-1 0 0 1 157 -501)"/>
                    </svg>
                    `;
            break;
    }

    const clicked = (event) => {
        if (to === '#') {
            event.preventDefault();
        }
        if (onClick) {
            onClick(event);
        }
        setClickEvent(true);
        timer = setTimeout(() => {
            setClickEvent(false);
        }, 100);
    };


    useEffect(() => {

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
        // eslint-disable-next-line
    }, []);

    return (
        <NavLink
            to={to}
            className={`${className} btn red ${(clickEvent) ? "clicked" : ""}`}
            onClick={(event) => clicked(event)}
            aria-label={ariaLabel}
            dangerouslySetInnerHTML={{ __html: html }}
        >
        </NavLink>
    );
};
export default Button;

